export default __webpack_public_path__ + "d37dbd64eef3a713d31eee684f05146a.png";